module.exports = __webpack_public_path__ + "img/RCT09.838abdff.svg";